module.exports = __webpack_public_path__ + "static/media/next-level-stream-3.ffe2750e.svg";